import { SET_ACTIVE_USER } from 'redux/actions/types/user';

export const setActiveUser = (user) => {
    return {
        type: SET_ACTIVE_USER,
        user
    }
}